var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7047 0.25C12.7105 0.25 13.678 0.6475 14.3897 1.36075C15.1022 2.0725 15.5005 3.0325 15.5005 4.0375V9.9625C15.5005 12.055 13.798 13.75 11.7047 13.75H4.29549C2.20224 13.75 0.500488 12.055 0.500488 9.9625V4.0375C0.500488 1.945 2.19474 0.25 4.29549 0.25H11.7047ZM12.553 4.15C12.3955 4.14175 12.2455 4.195 12.1322 4.3L8.75049 7C8.31549 7.36075 7.69224 7.36075 7.25049 7L3.87549 4.3C3.64224 4.1275 3.31974 4.15 3.12549 4.3525C2.92299 4.555 2.90049 4.8775 3.07224 5.1025L3.17049 5.2L6.58299 7.8625C7.00299 8.1925 7.51224 8.3725 8.04549 8.3725C8.57724 8.3725 9.09549 8.1925 9.51474 7.8625L12.898 5.155L12.958 5.095C13.1372 4.8775 13.1372 4.5625 12.9497 4.345C12.8455 4.23325 12.7022 4.165 12.553 4.15Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.86ed0baba8bf17bc7f919f370a21be37.svg";
export { ForwardRef as ReactComponent };